import { deepFreeze } from '../utils/deepFreeze';
import { EmailTemplates, DeepReadonly, ReminderNotificationsConfig, ApplicantReminderEmailTemplates } from 'types';

export const reminderNotificationsConfig: DeepReadonly<ReminderNotificationsConfig> = deepFreeze({
  emails: {
    [EmailTemplates.WELCOME]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.CAS_BYPASS_WELCOME]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.STUDENT_DETAILS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.HISTORY]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.FINANCE]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.OUTSTANDING_DOCUMENTS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.OUTSTANDING_FOLLOWUP_DOCUMENTS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.PRECAS_INTERVIEW]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.INTERVIEWS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.PASSPORT]: {},
    [EmailTemplates.DEPOSIT]: {},
    [EmailTemplates.VISA_1]: { repeat: 7, initialDelay: 2 },
    [EmailTemplates.VISA_1_LATE]: { repeat: 7, initialDelay: 2 },
    [EmailTemplates.VISA_2]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.VISA_2_LATE]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.ARRIVAL_1]: { repeat: 7, initialDelay: 1 },
    [EmailTemplates.ARRIVAL_2]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.ARRIVAL_3]: { initialDelay: 7 },
    [EmailTemplates.ARRIVAL_4]: { initialDelay: 1 },
    [EmailTemplates.NEW_INTERVIEWS]: { initialDelay: 1 },
    [EmailTemplates.READY_FOR_CAS]: { initialDelay: 1 },
    [EmailTemplates.DEFERRAL]: { initialDelay: 1 },

    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_2]: { initialDelay: 4 },
    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_3]: { initialDelay: 8 },
    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_4]: { initialDelay: 13 },

    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_4]: { initialDelay: 30 },

    [ApplicantReminderEmailTemplates.START_APPLICATION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.START_APPLICATION_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.START_APPLICATION_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.START_APPLICATION_4]: { initialDelay: 30, repeat: 30 }, // repeat every 1 month = every 30 days

    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_4]: { initialDelay: 30, repeat: 30 }, // repeat every 1 month = every 30 days

    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_4]: { initialDelay: 30, repeat: 30 }, // repeat every 1 month = every 30 days

    [ApplicantReminderEmailTemplates.UPDATE_STUDY_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.UPDATE_STUDY_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.UPDATE_STUDY_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.UPDATE_STUDY_4]: { initialDelay: 30 },

    [ApplicantReminderEmailTemplates.ACCEPT_YOUR_OFFER_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.ACCEPT_YOUR_OFFER_2]: { initialDelay: 7, repeat: 7 },

    [ApplicantReminderEmailTemplates.SATISFY_OFFER_CONDITION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.SATISFY_OFFER_CONDITION_2]: { initialDelay: 7, repeat: 7 },

    [ApplicantReminderEmailTemplates.CONFIRM_PAYMENT_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.CONFIRM_PAYMENT_2]: { initialDelay: 7, repeat: 7 }
  }
});
